// eslint-disable-next-line import/prefer-default-export
export const currencies = {
    1: '€',
    2: '$',
    3: '£',
};
